import React, { useEffect, useRef } from 'react';
import { Grid, MenuItem, TextField, Typography } from '@mui/material';
import { AccessRule } from 'types/accessRule';
import { AccessRuleValidation } from './validation/accessRuleValidation';

type AccessRuleFormProps = {
  accessRule: AccessRule;
  handleChange(index: string, value: string): void;
  validation: AccessRuleValidation;
  accessRules: AccessRule[];
};

const AccessRuleForm: React.FC<AccessRuleFormProps> = ({ accessRule, handleChange, validation, accessRules }) => {
  const inputs = {
    name: useRef<HTMLInputElement>(null),
    title: useRef<HTMLInputElement>(null),
    description: useRef<HTMLInputElement>(null),
  };

  useEffect(() => {
    const [key] = Object.keys(validation) as [keyof typeof inputs];

    if (!key) return;

    inputs[key].current?.focus();
  }, [validation]);

  return (
    <Grid container size={12} spacing={2} maxWidth={900}>
      <Grid size={12}>
        <Typography variant="subtitle2" fontWeight={700} color="primary">
          Dados da regra
        </Typography>
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <TextField
          select
          label="Pertence a"
          fullWidth
          value={accessRule.access_rule_id || ''}
          onChange={e => handleChange('access_rule_id', e.target.value)}
        >
          {accessRules
            .filter(item => item.id !== accessRule.id)
            .map(item => (
              <MenuItem value={item.id} key={item.id}>
                {item.title}
              </MenuItem>
            ))}
        </TextField>
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <TextField
          inputRef={inputs.name}
          error={!!validation.name}
          helperText={validation.name || 'Código usado pelo sistema para checar a permissão'}
          label="Nome da regra (código)"
          placeholder={'Ex: "registrations.resellers.approved"'}
          autoFocus
          fullWidth
          value={accessRule.name}
          onChange={e => handleChange('name', e.target.value)}
        />
      </Grid>

      <Grid size={{ xs: 12, md: 5 }}>
        <TextField
          inputRef={inputs.title}
          error={!!validation.title}
          helperText={validation.title}
          label="Título"
          placeholder={'Ex: "Cadastro > Clientes > Aprovados"'}
          fullWidth
          value={accessRule.title}
          onChange={e => handleChange('title', e.target.value)}
          autoComplete="none"
        />
      </Grid>

      <Grid size={{ xs: 12, md: 7 }}>
        <TextField
          inputRef={inputs.description}
          error={!!validation.description}
          helperText={validation.description}
          label="Descrição"
          placeholder={'Ex: "Gestão dos revendedores aprovados"'}
          fullWidth
          value={accessRule.description}
          onChange={e => handleChange('description', e.target.value)}
        />
      </Grid>
    </Grid>
  );
};

export default AccessRuleForm;
